import type { StripApiToken, StripFirmId } from '@seccl/api-swr';
import type { FetchTheme, FirmManagementApiNodeThemeFirmIdNodeIdGetRequest } from '@seccl/client';

import { useFirmId } from '../useFirmId';
import { firmApi } from './api';

type StrippedParams = StripFirmId<StripApiToken<FirmManagementApiNodeThemeFirmIdNodeIdGetRequest>>;

type GetNodeThemeParams = Omit<StrippedParams, 'nodeId'> & { nodeId?: string };

export const useGetNodeTheme = (params: GetNodeThemeParams, fallbackData?: FetchTheme) => {
  const firmId = useFirmId();
  const waitFor = !!firmId && typeof params.nodeId === 'string';

  return firmApi.nodeThemeFirmIdNodeIdGet.useQuery({
    cacheKey: ['firmId', 'nodeId'],
    params: { ...params, firmId },
    swrConfig: { fallbackData, revalidateOnMount: true },
    waitFor,
  });
};
